import DashboardAPI from '../apis/DashboardAPI';
import { iBinder, iBinderRequest, iPendingFinalReviewRecord, iPendingFinalReviewSearch, iProductivityRecord, iProductivityRecordSearch } from '../utilities/APIInterfaces';

class ReportService {
  async BinderRequest(binderRequest: iBinderRequest, loader: (v: boolean) => void) {
    loader(true);
    let response = await DashboardAPI.call({
      method: 'POST',
      route: 'Binder', 
      body: binderRequest
    });
    loader(false);
    return response;
  }

  async GetBinderPDF(binderRequest: iBinderRequest, loader: (v: boolean) => void): Promise<Blob | null> {
    loader(true);
    let binder = await DashboardAPI.callForFile({
      method: 'POST',
      route: 'Binder', 
      body: binderRequest
    });
    loader(false);
    return binder;
  }

  async GetRequestedBinders(opeId: string, loader: (v: boolean) => void): Promise<iBinder[]> {
    let binderData: iBinder[] = [];
    loader(true);
    binderData = await DashboardAPI.callForData<iBinder[]>({
      method: 'GET',
      route: `Binder/org/${opeId}`
    });
    loader(false);
    return binderData;
  }

  async GetPendingFinalReviewReport(opeId: string, loader: (v: boolean) => void): Promise<iPendingFinalReviewRecord[]> {
    let pendingFinalReviewReport: iPendingFinalReviewRecord[] = [];
    loader(true);
    pendingFinalReviewReport = await DashboardAPI.callForData<iPendingFinalReviewRecord[]>({
      method: 'GET',
      route: `SubmissionForm/Report/PendingFinalReview/Org/${opeId}`
    });
    loader(false);
    return pendingFinalReviewReport;
  }

  async SearchPendingFinalReviewReport(searchModel: iPendingFinalReviewSearch, loader: (v: boolean) => void): Promise<iPendingFinalReviewRecord[]> {
    let pendingFinalReviewReport: iPendingFinalReviewRecord[] = [];
    loader(true);
    searchModel.statusAfterQc = searchModel.statusAfterQc === 0 ? undefined : searchModel.statusAfterQc;
    pendingFinalReviewReport = await DashboardAPI.callForData<iPendingFinalReviewRecord[]>({
      method: 'POST',
      route: `SubmissionForm/Report/PendingFinalReview/`,
      body: searchModel
    });
    loader(false);
    return pendingFinalReviewReport;
  }

  async GetProductivityReport(opeId: string, loader: (v: boolean) => void): Promise<iProductivityRecord[]> {
    let productivityReport: iProductivityRecord[] = [];
    loader(true);
    productivityReport = await DashboardAPI.callForData<iProductivityRecord[]>({
      method: 'GET',
      route: `SubmissionForm/Report/Productivity/Org/${opeId}`
    });
    loader(false);
    return productivityReport;
  }

  async SearchProductivityReport(searchModel: iProductivityRecordSearch, loader: (v: boolean) => void): Promise<iProductivityRecord[]> {
    let productivityReport: iProductivityRecord[] = [];
    loader(true);
    searchModel.statusAfterInReview = searchModel.statusAfterInReview === 0 ? undefined : searchModel.statusAfterInReview;
    productivityReport = await DashboardAPI.callForData<iProductivityRecord[]>({
      method: 'POST',
      route: `SubmissionForm/Report/Productivity/`,
      body: searchModel
    });
    loader(false);
    return productivityReport;
  }
}

const reportService = new ReportService();
export default reportService;